/*
 * Code Messages
 *
 * This contains all the text for the Code component.
 */

import { defineMessages } from 'react-intl';

export const scope = 'components.Code';

export default defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: 'Access Code',
  },
  validFor: {
    id: `${scope}.validFor`,
    defaultMessage: 'Valid for',
  },
  minutes: {
    id: `${scope}.minutes`,
    defaultMessage: 'minutes',
  },
  createAccessCode: {
    id: `${scope}.createAccessCode`,
    defaultMessage: 'Create Access Code',
  },
  activeAccessCodes: {
    id: `${scope}.activeAccessCodes`,
    defaultMessage: 'Active Access Codes',
  },
  code: {
    id: `${scope}.code`,
    defaultMessage: 'Code',
  },
  expirationTime: {
    id: `${scope}.expirationTime`,
    defaultMessage: 'Expiration Time',
  },
  cancel: {
    id: `${scope}.cancel`,
    defaultMessage: 'Cancel',
  },
});
